import { Component, OnInit } from '@angular/core';

import { HttpService } from '../../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/models/appConstants';

@Component({
  selector: 'app-consent-timeline',
  templateUrl: './consent-timeline.component.html',
  styleUrls: ['./consent-timeline.component.scss']
})

export class ConsentTimelineComponent {

  constructor(
    private http: HttpService,
    private activatedRoute: ActivatedRoute,
    private appConstants: AppConstants,
    private _route: Router
  ) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.consentArtefactId = params.id;
    this.getConsentTimeline();
    this.setBreadcrumb();
  })
  }

  // day = "Today"
  day: String;
  consentArtefactId = '';//"02f94791-2f97-45af-bcf0-4b816fc6442c"; //TODO: take from URL
  consentInfo: any;
  fiuDetails: any;
  consentEvents=[];
  fiuIcon: String;
  purpose: String;
  bankAccountType: String;
  bankName: String;
  expiry: String;
  today: number = Date.now();
  breadcrumb: { "label": string; "link": any[]; }[] = [];

  getConsentTimeline() {
    let options = {
      type: 'get',
      url: 'consentTimeline',
      includeUserSession: true,
      pathVariables: [this.consentArtefactId],
      isDeveloper:true
      //isLocal: true
    }
    this.http.makeHttpRequest(options).subscribe((res) => {
      this.createTimeLine(res);
      // this.consentInfo = res["consentInfo"];
      // this.consentEvents = res["events"];
      // this.fiuDetails = res["fiuDetails"];
      // this.fiuIcon = this.fiuDetails.url ? this.fiuDetails.url : "./assets/images/instaloan.png";
      // this.purpose = this.consentInfo.purpose;
      // this.expiry = this.consentInfo.expiration;
      // this.day = this.consentEvents[0].time;
    });

  }
  createTimeLine(res) {
    if(!this.appConstants.consentData){
      this._route.navigate(['/dashboard']);
    }else{
    var self = this;
    var currentAccountDetails = this.appConstants.consentData['activeConsentBanksList'].find(o=> o.consentArtefactId == self.consentArtefactId);
    this.purpose = this.appConstants.consentData['purpose'];
    this.expiry = this.appConstants.consentData['expireTime'];
    this.bankName = currentAccountDetails['fipName'];
    this.bankAccountType = currentAccountDetails['nickName'];
    this.consentEvents = res;
    this.consentEvents.unshift({
      timeStamp: currentAccountDetails.startTime,
      eventType: "LINKED",
      status: "APPROVED"
    });
    //appConstants
    
  }
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Consent Timeline", "link": ["http://google.com"] },
    ];
  }
}
